var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBulb2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5556 19.92V20.9467C15.5556 21.3298 15.2587 21.6556 14.8444 21.7764V22.12C14.8444 22.606 14.3669 23 13.7778 23H10.2222C9.63311 23 9.15556 22.606 9.15556 22.12V21.7764C8.74133 21.6556 8.44444 21.3298 8.44444 20.9467V19.92C8.44444 19.677 8.68324 19.48 8.97778 19.48H15.0222C15.3168 19.48 15.5556 19.677 15.5556 19.92ZM9.42857 9.24248C9.42857 7.67526 10.7103 6.40025 12.2857 6.40025C12.6802 6.40025 13 6.0821 13 5.68969C13 5.29728 12.6802 4.97913 12.2857 4.97913C9.92254 4.97913 8 6.89164 8 9.24248C8 9.63489 8.31982 9.95304 8.71429 9.95304C9.10875 9.95304 9.42857 9.63489 9.42857 9.24248ZM12 2.98957C15.3157 2.98957 18 5.56046 18 8.7372C18 12.2218 16.2477 11.4528 14.2041 15.9217H9.79594C7.74928 11.4462 6 12.2338 6 8.7372C6 5.56096 8.68378 2.98957 12 2.98957ZM12 1C7.58205 1 4 4.47047 4 8.75101C4 13.2312 6.34986 12.7825 8.11436 17.2363C8.27573 17.6437 8.68118 17.9113 9.13145 17.9113H14.8685C15.3188 17.9113 15.7242 17.6436 15.8856 17.2363C17.6501 12.7825 20 13.2312 20 8.75101C20 4.47047 16.418 1 12 1Z",
    fill: "#6A747F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBulb2);
export default __webpack_public_path__ + "static/media/img_bulb_2.39ad458fc501973e1ab2889799a037de.svg";
export { ForwardRef as ReactComponent };